import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';
import organizationFields from '../../fields/organizationFields';
import ORGANIZATION_TYPES from '../../enums/OrganizationTypes';
import { extractDataToSendFromObject } from '@/common-utils/functions/extractDataFromObject';

const mutationUpdateOrganization = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, organizationData, shouldBlockNewPOS }) => {
            const businessName = organizationData[organizationFields.LEGAL_INFOS.key] ?
                organizationData[organizationFields.LEGAL_INFOS.key][organizationFields.LEGAL_INFOS.BUSINESS_NAME.key] : '';

            const organizationDataToUpdate = {
                [organizationFields.UUID.key]: organizationId,
                [organizationFields.SHOULD_BLOCK_NEW_POS.key]: shouldBlockNewPOS,
                [organizationFields.LEGAL_INFOS.BUSINESS_NAME.key]: businessName,
                ...extractDataToSendFromObject(
                    organizationData,
                    [
                        organizationFields.LEGAL_NAME,
                        organizationFields.REGISTRATION_NUMBER,
                        organizationFields.TYPE,
                        organizationFields.CLIENT_CODE,
                        organizationFields.BRAND.UUID,
                        organizationFields.BRAND.DOMAIN_NAME,
                        organizationFields.BRAND.STYLE.MAIN_COLOR,
                        organizationFields.BRAND.STYLE.ASSETS.LOGO,
                        organizationFields.COMMENT,
                        organizationFields.BILLABLE,
                        organizationFields.BILLING_ID_READ
                    ]
                )
            };
            // Prevent non white-label brand updates
            if (organizationDataToUpdate[organizationFields.TYPE.key] !== ORGANIZATION_TYPES.WHITE_LABEL.name) {
                delete organizationDataToUpdate[organizationFields.BRAND.key];
            }

            return client.put(
                replaceParameters(ORGANIZATION.DETAILS.url, { organizationId }, organizationDataToUpdate),
                organizationDataToUpdate
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateOrganization;